/* globals Qforms */

window['employee_qforms#edit'] = function () {
  Qforms.initHints()
}
